import type { CaseDetail } from '@/mocks/portfolio';

const patexCase: CaseDetail = {
  id: 'patex',
  project: 'パテックス 機能性サポーター 店頭資材のご提案',
  client: '第一三共ヘルスケア',
  year: 'Archive',
  category: 'Retail / Communication',
  role: 'Promotion / Retail / Communication / Store Tool Design',
  issue: '膝や腰の痛みへの対処としてサポーターが身近ではなく、売場においても立寄りが少なく、購買判断基準を持たないターゲットに対して、ブランド価値訴求を効果的に行い、売場視認から購買決定までを強力に促進することが課題だった。',
  challenge: '機能性サポーターの効果が専門的で伝わりにくく、一般層への訴求が弱かった。専門的な機能性を、生活者にわかりやすく信頼できる形で伝えること。',
  insight: '「体の悩みへの寄り添い」が、機能の説明より生活者の心に響く。膝や腰に悩みを抱えた50〜60代のシニア女性層に向けた、「高機能による快適生活実現サポーター」という訴求メッセージが共感を呼ぶ。',
  strategy: '「高機能による快適生活実現サポーター」をコアコンセプトに、4つの戦略ポイントで展開。（1）ブランドイメージの統合的な訴求で売場コーナー化・登場感演出、（2）ワコール共同開発の強力な訴求で高価格への納得感と高機能への期待感醸成、（3）ターゲットインサイトに基づく訴求内容で購買意欲喚起、（4）購買行動を促進するツール構成で認知→関心→選択→共感の接点設計。',
  experience: '店頭、パッケージ、コミュニケーションを通じて、機能と安心を伝える体験を構築。定番売場用ディスプレイとクロス売場用ディスプレイの2軸で、膝用・腰用サポーターの展開を設計。吊り下げディスプレイ、見本入れ用資材、エンド陳列、ボード類など豊富な店頭資材で購買導線を構成。',
  output: '店頭資材ご提案 / ディスプレイボード（定番売場・クロス売場） / 吊り下げディスプレイ / 見本入れ用資材 / エンド陳列什器 / ボード類 / 戦略企画書',
  impact: '機能価値の理解と、商品への信頼感向上を実現。売場での視認性向上と購買行動の促進を設計。',
  images: [
    {
      src: '/assets/migrated/a7f354f95ce175523101.webp',
      caption: '第一三共ヘルスケア パテックス新登場 — スゴイサポーターが出た！ワコール共同開発。ひざを快適に！腰を快適に！',
    },
    {
      src: '/assets/migrated/03101247da0db9a22e3d.webp',
      caption: '生活者の「痛み」への対処意識とサポーターを使うキッカケ — ターゲットプロファイルと購買行動分析',
    },
    {
      src: '/assets/migrated/55bab3e8b1f5b18f9e80.webp',
      caption: 'ポジショニング戦略 — パテックス機能性サポーターはサポーターカテゴリーを「さらに増強」するパワーアイテム！50-60代女性ターゲット',
    },
    {
      src: '/assets/migrated/7bf37e3347a7d1fc9d2d.webp',
      caption: '課題と戦略ポイント — 高機能による快適生活実現サポーター。ブランドイメージ統合・ワコール共同開発・ターゲットインサイト・購買促進ツールの4本柱',
    },
    {
      src: '/assets/migrated/c1f555f3c9813ced8935.webp',
      caption: '店頭資材ご提案 — ディスプレイボード付き（定番売場用ディスプレイ・クロス売場用ディスプレイ）',
    },
    {
      src: '/assets/migrated/0a7db6812977162cdb85.webp',
      caption: '店頭展開資料 — ディスプレイ・吊り下げディスプレイ・見本入れ用資材・エンド陳列の展開イメージ',
    },
    {
      src: '/assets/migrated/627208750573dc69a1c2.webp',
      caption: '売場イメージ — 定番売場陳列とクロス売場陳列の展開イメージ',
    },
    {
      src: '/assets/migrated/4b7736b7bb937a336979.webp',
      caption: 'ボード展開 — 定番売場用ボード（スゴイサポーターが出た！）とクロス売場用ボード（あなたはどっちのパテックス？）',
    },
    // Round 3 — 2026.08.23 新規追加
    {
      src: '/assets/migrated/b3f498d094d312007f18.webp',
      caption: 'ツールデザイン サムネイル — Page 14 認知→関心→選択→共感の購買行動プロセス別 全ツール一覧（ボード・ディスプレイ・吊り下げ・見本入れ・売場別アテンションPOP・メジャーツール・パンフレット）',
    },
    {
      src: '/assets/migrated/96a80d1bdf4d59e2c007.webp',
      caption: '定番売場用ディスプレイ（スゴイサポーターが出た！ワコール共同開発）/ クロス売場用ディスプレイ（あなたはどっちのパテックス？着ける・貼る）— 定番・クロス2種の実寸ディスプレイ完成イメージ',
    },
    {
      src: '/assets/migrated/00bd8920516a04a49e19.webp',
      caption: '店頭で提供する動機形成（Page 8）/ 購買行動プロセスを前進させるツール構成（Page 9）/ 売場別ツールの使い分け（Page 11）/ 購買プロセス全体のフレームワーク（Page 10）— 4ページ複合資料',
    },
  ],
};

export default patexCase;